import { createSlice } from "@reduxjs/toolkit"

export const customerOrderListSlice = createSlice({
	name: "customerOrder_list",
	initialState: {
		customerOrder: "",
		errors: [],
	},

	reducers: {
        getCustomerOrder: (state, action) => {
            // console.log(action.payload);
			state.customerOrder = action.payload
		},
		getCustomerOrderList: (state, action) => {
			state.customerOrder = action.payload
		},
		getErrors: (state, action) => {
            // console.log(action.payload);
			state.errors = action.payload
		},
	},
})
export const {getCustomerOrder, getCustomerOrderList, getErrors} = customerOrderListSlice.actions

export default customerOrderListSlice.reducer
